// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2d6Pk","top":"styles_top__2rAq9"};